// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_IOs7F{--disclaimerMarginBottom:10px}@media only screen and (min-width:768px){.root_IOs7F{--disclaimerMarginBottom:15px}}.root_IOs7F{width:100%}.disclaimer_LqemA,.general_e9fng{margin-bottom:var(--disclaimerMarginBottom);font-size:14px;line-height:18px;color:#5f5f5f}.general_e9fng{font-style:italic}.warning_-sJ4F{margin-bottom:var(--disclaimerMarginBottom);align-items:center}.warning_-sJ4F,.warningIconContainer_t3kOl{display:flex}.warningIcon_yebkM{width:22px;height:22px;margin-right:6px}.warningBody_oPsFx p{font-size:14px;line-height:18px;font-weight:300;color:#252525;white-space:pre-line}.warningBody_oPsFx p strong{font-weight:700}.warningBody_oPsFx p a{color:inherit}", ""]);
// Exports
exports.locals = {
	"root": "root_IOs7F",
	"disclaimer": "disclaimer_LqemA",
	"general": "general_e9fng",
	"warning": "warning_-sJ4F",
	"warningIconContainer": "warningIconContainer_t3kOl",
	"warningIcon": "warningIcon_yebkM",
	"warningBody": "warningBody_oPsFx"
};
module.exports = exports;
